import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import { useTitle } from 'features/views/dashboard/hooks';

import CampaignManagement from './CampaignManagement';
import Statistics from './Statistics';
import TodaysUrgencies from './TodaysUrgencies';

export const MainWidgets = () => {
	const title = useTitle();

	return (
		<Grid container spacing={2} sx={{ zIndex: 2, justifyContent: 'center' }}>
			<Grid size={12}>
				<Typography
					color="white.main"
					variant="h2"
					sx={{
						fontWeight: 'light',
						ml: 2,
					}}
				>
					{title}
				</Typography>
			</Grid>
			<Grid size={12}>
				<TodaysUrgencies />
			</Grid>
			<Grid size={12}>
				<Statistics />
			</Grid>
			<Grid size={12}>
				<CampaignManagement />
			</Grid>
		</Grid>
	);
};

export default MainWidgets;
